export const MODIFIED_ICON = `fa fa-asterisk`;
export const DASHBOARD_OWNER_ICON = `pi pi-user`;
export const DASHBOARD_COLLABORATOR_ICON = `pi pi-users`;
export const DASHBOARD_VIEWER_ICON = `pi pi-eye`;
export const DASHBOARD_ADMIN_ICON = `pi pi-id-card`;
export const DASHBOARD_UNKNOWN_ICON = `pi pi-question-circle`;
export const UNMODIFIED_DASHBOARD_CONFIG_ICON = `fa fa-book`;
export const UNMODIFIED_HTML_ICON = `fa fa-newspaper-o`;
export const UNMODIFIED_PDF_ICON = `fa fa-file-pdf-o`;
export const UNMODIFIED_XLSX_ICON = `fa fa-file-excel-o`;
// const UNMODIFIED_COMPONENT_ICON = `fa fa-sticky-note-o`;
export const UNMODIFIED_COMPONENT_INVESTIGATION_ICON = `fa fa-binoculars`;
export const UNMODIFIED_COMPONENT_DOWNLOAD_ICON = `fa fa-cloud-download`;
export const UNMODIFIED_COMPONENT_PIE_CHART_ICON = `fa fa-pie-chart`;
export const UNMODIFIED_COMPONENT_BAR_CHART_ICON = `fa fa-bar-chart`;
export const UNMODIFIED_COMPONENT_TABLE_ICON = `fa fa-table`;
export const UNMODIFIED_COMPONENT_COMPARISON_ICON = `fa fa-exchange`;
export const UNMODIFIED_COMPONENT_PIVOT_ICON = `fa fa-th`;
export const UNMODIFIED_COMPONENT_INVENTORY_ICON = `fa fa-list-alt`;
export const UNMODIFIED_COMPONENT_CUSTOM_ICON = `fa fa-file-code-o`;


export function getIconForComponent(usage: string, componentType: string, chartType?: string): string {
    let iconToUse;
    if (usage === 'DASHBOARD') {
        if (componentType === 'PIVOT') {
            iconToUse = UNMODIFIED_COMPONENT_PIVOT_ICON;
        } else if (componentType === 'TABLE') {
            iconToUse = UNMODIFIED_COMPONENT_TABLE_ICON;
        } else if (componentType === 'COMPARISON_TABLE') {
            iconToUse = UNMODIFIED_COMPONENT_COMPARISON_ICON;
        } else if (componentType === 'CHART') {
            if (chartType === 'PIE') {
                iconToUse = UNMODIFIED_COMPONENT_PIE_CHART_ICON;
            } else if (chartType === 'BAR' ||
                chartType === 'COLUMN') {
                iconToUse = UNMODIFIED_COMPONENT_BAR_CHART_ICON;
            }
        } else if (componentType === 'CUSTOM') {
            iconToUse = UNMODIFIED_COMPONENT_CUSTOM_ICON;
        }
    } else if (usage === 'INVENTORY') {
        iconToUse = UNMODIFIED_COMPONENT_INVENTORY_ICON;
    } else if (usage === 'INVESTIGATION') {
        iconToUse = UNMODIFIED_COMPONENT_INVESTIGATION_ICON;
    } else if (usage === 'DOWNLOAD') {
        iconToUse = UNMODIFIED_COMPONENT_DOWNLOAD_ICON;
    }
    return iconToUse;
}
